import React, { useState } from 'react';
import {
    Form,
    FormH1,
    FormH4,
    FormInfoText,
    FormInfoValue,
    InfoContainer,
    SelectButton,
    LoadButton,
    TeamCard,
    TeamCardContainer,
    TopLine,
    ValueWrapper,
    SpinningIcon,
    LockedIcon,
    RowContainer,
    TeamContainer,
    SlotCard,
    TextWrapper,
    HeadingHelpersContainer,
    VStack
} from '../TeamDisplayForms/TeamDisplayElements'
import CaptainTableRow from './ClassicTableRow';
import TeamPlayerCard from '../TeamDisplayForms/TeamPlayerCard'
import TeamSlotCard from '../TeamDisplayForms/TeamSlotCard'
import { RowGroup, StyledIconGraph, StyledIconGrid, StyledIconList, StyledIconTable, TeamWrapper, ViewSlectionRow } from './ClassicTeamTableElements';

import { VictoryBar, VictoryChart, VictoryAxis, VictoryTooltip, VictoryTheme } from 'victory';
import ClassicTableRow from './ClassicTableRow';


const ClassicTeamTable = ({ team, listStatus, handleRemove, handleReset, handleOptimize, loadingBoolean, handleSaveTeam, handleFill }) => {

    const [view, setView] = useState("List");
    const [view2, setView2] = useState(false);


    const teamCost = team.assetList.reduce((total, currentValue) => total = total + currentValue.currentCost, 0);

    const teamProjection = team.assetList.reduce((total, currentValue) => total = total + currentValue.dkPoints, 0).toFixed(2);

    const qb = team.assetList.filter(player => player.position === 'QB')

    const rbList = team.assetList.filter(player => player.position === 'RB')

    const wrList = team.assetList.filter(player => player.position === 'WR')

    const teList = team.assetList.filter(player => player.position === 'TE')

    const dst = team.assetList.filter(player => player.position === 'DST')

    const rb1Check = rbList.length > 0 ? true : false
    const rb2Check = rbList.length > 1 ? true : false
    const rb3Check = rbList.length > 2 ? true : false

    const wr1Check = wrList.length > 0 ? true : false
    const wr2Check = wrList.length > 1 ? true : false
    const wr3Check = wrList.length > 2 ? true : false
    const wr4Check = wrList.length > 3 ? true : false

    const te1Check = teList.length > 0 ? true : false
    const te2Check = teList.length > 1 ? true : false

    const flexList = wr4Check ? wrList : rb3Check ? rbList : te2Check ? teList : null
    const dstCheck = dst.length > 0 ? true : false
    return (
        <>
            {listStatus ? (
                <InfoContainer lightBg={true} >
                    <Form>
                        <FormH1>Crew Builder</FormH1>
                        <HeadingHelpersContainer >
                            <VStack style={{ justifyContent: 'space-evenly' }}>
                                <ValueWrapper>
                                    <FormInfoText>Projection: </FormInfoText>
                                    <FormInfoValue errorText={true}>{teamProjection}</FormInfoValue>
                                </ValueWrapper>
                                <ValueWrapper>
                                    <FormInfoText>Crew Cost: </FormInfoText>
                                    <FormInfoValue errorText={teamCost <= 50000}>${teamCost.toLocaleString()}</FormInfoValue>
                                </ValueWrapper>
                                <ValueWrapper>
                                    <FormInfoText>Remaining : </FormInfoText>
                                    <FormInfoValue errorText={true}>${50000 - teamCost}</FormInfoValue>
                                </ValueWrapper>
                            </VStack>
                            <VStack>
                                <SelectButton style={{ width: '100px', justifySelf: 'center', marginBottom: '0px', marginTop: '0px' }} onClick={(e) => handleReset(e)}>Reset</SelectButton>
                                {/* <SelectButton style={{ width: '100px', justifySelf: 'center', marginBottom: '0px' }} onClick={(e) => handleFill(e, "")}>Player Search</SelectButton> */}
                            </VStack>
                        </HeadingHelpersContainer>
                    </Form>
                    <ViewSlectionRow>
                        <RowGroup>
                            <StyledIconList selected={view === "List"} onClick={(e) => setView("List")} />
                            <StyledIconGrid selected={view === "Grid"} onClick={(e) => setView("Grid")} />
                        </RowGroup>
                        <StyledIconGraph selected={view2} onClick={(e) => setView2(!view2)} />
                    </ViewSlectionRow>
                    {view === "List" && <TeamWrapper>
                        <>
                            {qb && qb.length > 0
                                ? qb.map((p, ind) => (
                                    <ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />
                                ))
                                : <ClassicTableRow position="Quarterback" handleFill={handleFill} />
                            }
                        </>
                        <>
                            {/* <TopLine>Running Back</TopLine> */}
                            {rb1Check ? (rbList.filter((p, ind) => ind === 0).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Running Back" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Running Back</TopLine> */}
                            {rb2Check ? (rbList.filter((p, ind) => ind === 1).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Running Back" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Wide Receiver</TopLine> */}
                            {wr1Check ? (wrList.filter((p, ind) => ind === 0).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Wide Receiver" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Wide Receiver</TopLine> */}
                            {wr2Check ? (wrList.filter((p, ind) => ind === 1).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Wide Receiver" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Wide Receiver</TopLine> */}
                            {wr3Check ? (wrList.filter((p, ind) => ind === 2).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Wide Receiver" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Tight End</TopLine> */}
                            {te1Check ? (teList.filter((p, ind) => ind === 0).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="TE" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Flex</TopLine> */}
                            {flexList ? (flexList.filter((p, ind) => ind === flexList.length - 1).map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Flex" handleFill={handleFill} />}
                        </>
                        <>
                            {/* <TopLine>Defense</TopLine> */}
                            {dstCheck ? (dst.map((p, ind) => (<ClassicTableRow key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <ClassicTableRow position="Defense/ Special Teams" handleFill={handleFill} />}
                        </>
                    </TeamWrapper>
                    }
                    {view === "Grid" && <TeamContainer>
                        <TeamCardContainer>
                            {qb && qb.length > 0
                                ? qb.map((p, ind) => (
                                    <TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />
                                ))
                                : <TeamSlotCard position="Quarterback" handleFill={handleFill} />
                            }
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Running Back</TopLine> */}
                            {rb1Check ? (rbList.filter((p, ind) => ind === 0).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Running Back" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Running Back</TopLine> */}
                            {rb2Check ? (rbList.filter((p, ind) => ind === 1).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Running Back" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Wide Receiver</TopLine> */}
                            {wr1Check ? (wrList.filter((p, ind) => ind === 0).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Wide Receiver" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Wide Receiver</TopLine> */}
                            {wr2Check ? (wrList.filter((p, ind) => ind === 1).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Wide Receiver" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Wide Receiver</TopLine> */}
                            {wr3Check ? (wrList.filter((p, ind) => ind === 2).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Wide Receiver" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Tight End</TopLine> */}
                            {te1Check ? (teList.filter((p, ind) => ind === 0).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="TE" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Flex</TopLine> */}
                            {flexList ? (flexList.filter((p, ind) => ind === flexList.length - 1).map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Flex" handleFill={handleFill} />}
                        </TeamCardContainer>
                        <TeamCardContainer>
                            {/* <TopLine>Defense</TopLine> */}
                            {dstCheck ? (dst.map((p, ind) => (<TeamPlayerCard key={ind} player={p} index={0} handleRemove={handleRemove} />)))
                                : <TeamSlotCard position="Defense/ Special Teams" handleFill={handleFill} />}
                        </TeamCardContainer>
                    </TeamContainer>}
                    {view2 && <TeamWrapper>
                        <VictoryChart
                            theme={VictoryTheme.clean}
                            domainPadding={25}
                            padding={{ top: 20, bottom: 60, left: 50, right: 30 }}
                            width={500}
                            height={300}
                        >
                            {/* X Axis */}
                            <VictoryAxis
                                tickValues={team.assetList.map((_, i) => i + 1)}
                                tickFormat={team.assetList.map(d => d.name)}
                                style={{
                                    axis: { stroke: '#000' },
                                    tickLabels: {
                                        fill: '#006ee6',
                                        fontSize: 10,
                                        fontFamily: 'sans-serif',
                                        angle: -25,
                                        textAnchor: 'end',
                                        padding: 5
                                    }
                                }}
                            />

                            {/* Y Axis */}
                            <VictoryAxis
                                dependentAxis
                                style={{
                                    axis: { stroke: '#000' },
                                    grid: { stroke: 'rgba(255, 255, 255, 0.05)' },
                                    tickLabels: { fill: '#000', fontSize: 11, fontFamily: 'sans-serif' }
                                }}
                            />

                            {/* Bar Chart Data */}
                            <VictoryBar
                                data={team.assetList.map((x, i) => ({
                                    index: i + 1,
                                    name: x.name,
                                    dkPoints: x.dkPoints,
                                    cost: x.cost
                                }))}
                                x="index"
                                y="dkPoints"
                                labels={({ datum }) => `${datum.name}: ${datum.dkPoints}`}
                                labelComponent={
                                    <VictoryTooltip
                                        flyoutStyle={{
                                            stroke: '#000',
                                            fill: '#2a2a35',
                                            strokeWidth: 1,
                                        }}
                                        style={{ fill: '#ffffff', fontSize: 10, fontFamily: 'sans-serif' }}
                                        cornerRadius={6}
                                        pointerLength={6}
                                    />
                                }
                                style={{
                                    data: {
                                        fill: '#006ee6',
                                        width: 28,
                                    }
                                }}
                                cornerRadius={{ top: 6 }}
                                animate={{
                                    duration: 500,
                                    onLoad: { duration: 500 }
                                }}
                            />
                        </VictoryChart>

                    </TeamWrapper>
                    }
                    <Form>
                        {/* <LoadButton onClick={handleOptimize(team)} disabled={loadingBoolean} primary={loadingBoolean}>  Uncomment this line and comment below line if you want to turn on optimizer */}
                        {/* <LoadButton style={{ width: '200px', justifySelf: 'center' }} onClick={handleOptimize(team)} disabled={loadingBoolean} primary={loadingBoolean}> */}
                        {/* <LockedIcon /> */}
                        {/* {loadingBoolean && (
                                <SpinningIcon />
                            )}
                            {loadingBoolean && <span>Filling (Team may be suboptimal)</span>}
                            {!loadingBoolean && <span>Quick Fill</span>}
                        </LoadButton> */}
                    </Form>
                    <Form>
                        <LoadButton style={{ width: '200px', justifySelf: 'center' }} onClick={handleSaveTeam("")}>Save Team</LoadButton>
                    </Form>
                    {/* {
                            team.assetList.map((p, ind) => (
                                <TeamPlayerCard player={p} index={ind} handleRemove={handleRemove} />
                            ))} */}
                </InfoContainer >
            ) :
                <InfoContainer></InfoContainer>

            }
        </>
    )
};

export default ClassicTeamTable;